module.exports = __webpack_public_path__ + "static/now-discover-your-strengths-486b11daf9a932ecbbefc6b9ea366048.jpg";